import addCustomerMessages from './AddCustomer/en-US';
import addLocationMessages from './AddLocation/en-US';
import manageCustomerMessages from './ManageCustomers/en-US';
import massImportLocationsMessages from './MassImportLocations/en-US';
import type ISyscoSelfServiceMessages from '.';

const syscoSelfServiceMesages: ISyscoSelfServiceMessages = {
	manageCustomer: manageCustomerMessages,
	addCustomer: addCustomerMessages,
	addLocation: addLocationMessages,
	massImportLocations: massImportLocationsMessages,
};

export default syscoSelfServiceMesages;
